import { render } from "./dashboardNoMenu.vue?vue&type=template&id=f7fcda52&scoped=true"
import script from "./dashboardNoMenu.vue?vue&type=script&lang=js"
export * from "./dashboardNoMenu.vue?vue&type=script&lang=js"

import "./dashboardNoMenu.vue?vue&type=style&index=0&id=f7fcda52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7fcda52"]])

export default __exports__